<form [formGroup]="formGroup" class="flex flex-col">
  <mat-form-field>
    <mat-label>{{'customer_form.title' | translate }}</mat-label>
    <input formControlName="title" matInput />
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'customer_form.last_name' | translate }}</mat-label>
    <input formControlName="lastname" matInput />
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{'customer_form.first_name' | translate }}</mat-label>
    <input formControlName="firstname" matInput />
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{'customer_form.nationality' | translate }}</mat-label>
    <input formControlName="nationality" matInput />
  </mat-form-field>

  <ng-container formGroupName="contact">
    <ng-container formGroupName="address">
      <div class="flex gap-x-4 flex-col md:flex-row w-full">
        <mat-form-field class="w-full">
          <mat-label>{{'customer_form.street' | translate }}</mat-label>
          <input formControlName="streetName" matInput />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'customer_form.house_number' | translate }}</mat-label>
          <input formControlName="buildingNumber" matInput />
        </mat-form-field>
      </div>

      <ng-container *ngIf="countrySettings !== 'DE'">
          <div class="flex gap-x-4 flex-col md:flex-row w-full">
            <mat-form-field class="w-full">
              <mat-label>{{'stairway' | translate}}</mat-label>
              <input formControlName="stairway" matInput />
            </mat-form-field>
            <mat-form-field class="w-full">
              <mat-label>{{'door_number' | translate}}</mat-label>
              <input formControlName="doorNumber" matInput />
            </mat-form-field>
          </div>
      </ng-container>

      <div class="flex gap-x-4 flex-col md:flex-row w-full">
        <mat-form-field class="w-full">
          <mat-label>{{'customer_form.zip_code' | translate }}</mat-label>
          <input formControlName="zipCode" matInput />
        </mat-form-field>
        <mat-form-field class="w-full">
          <mat-label>{{'customer_form.city' | translate }}</mat-label>
          <input formControlName="city" matInput />
        </mat-form-field>
      </div>

      <mat-form-field>
        <mat-label>{{'customer_form.country' | translate }}</mat-label>
        <input formControlName="country" matInput />
      </mat-form-field>

    </ng-container>
  </ng-container>

  <mat-form-field>
    <mat-label>{{'customer_form.date_of_birth' | translate }}</mat-label>
    <input matInput [matDatepicker]="birthday" [max]="maxDate" formControlName="birthdate" [placeholder]="('customer_form.dob_placeholder' | translate)" />
    <mat-error *ngIf="isBirthdateValid">{{'alerts.invalid_age' | translate }}</mat-error>
    <mat-datepicker-toggle matSuffix [for]="birthday"></mat-datepicker-toggle>
    <mat-datepicker #birthday touchUi disabled="false" color="primary"></mat-datepicker>
  </mat-form-field>

  <ng-container formGroupName="contact">
    <mat-form-field class="w-full">
      <mat-label>{{'customer_form.phone' | translate }}</mat-label>
      <input formControlName="phone" matInput />
      <mat-hint align="start" class="text-xxs">{{'customer_form.phone_hint' | translate }}</mat-hint>
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>{{'customer_form.email' | translate }}</mat-label>
      <input formControlName="email" matInput required />
      <mat-error *ngIf="isEmailValid">{{'alerts.email_invalid' | translate }}</mat-error>
    </mat-form-field>
  </ng-container>

    <ng-container formGroupName="pep" *ngIf="countrySettings !== 'DE' && showPep">

        <mat-accordion class="mb-4">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="font-semibold">
                        {{'customer_form.open_pep_hint' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="italic">
                    {{'customer_form.pep_hint' | translate}}
                    <ul>
                        <li class="list-disc ml-4">{{'customer_form.pep_hint_1' | translate}}</li>
                        <li class="list-disc ml-4">{{'customer_form.pep_hint_2' | translate}}</li>
                    </ul>
                </div>

            </mat-expansion-panel>
        </mat-accordion>

        <label id="is-pep-label">{{'customer_form.is_Pep' | translate}}:</label>
        <mat-radio-group aria-labelledby="is-pep-label" formControlName="isPep">
            <mat-radio-button [value]="true">{{'questionnaire.yes' | translate}}</mat-radio-button>
            <mat-radio-button [value]="false">{{'questionnaire.no' | translate}}</mat-radio-button>
        </mat-radio-group>
        <label id="was-pep-label">{{'customer_form.was_Pep' | translate}}:</label>
        <mat-radio-group aria-labelledby="was-pep-label" formControlName="wasPepLastYear">
            <mat-radio-button [value]="true">{{'questionnaire.yes' | translate}}</mat-radio-button>
            <mat-radio-button [value]="false">{{'questionnaire.no' | translate}}</mat-radio-button>
        </mat-radio-group>
        <label id="is-family-pep-label">{{'customer_form.is_Family_Pep' | translate}}:</label>
        <mat-radio-group aria-labelledby="is-family-pep-label" formControlName="isFamilyMemberPep">
            <mat-radio-button [value]="true">{{'questionnaire.yes' | translate}}</mat-radio-button>
            <mat-radio-button [value]="false">{{'questionnaire.no' | translate}}</mat-radio-button>
        </mat-radio-group>
        <label id="is-known-pep-label">{{'customer_form.is_Known_Pep' | translate}}:</label>
        <mat-radio-group aria-labelledby="is-known-label" formControlName="isKnownToBeCloseToPep">
            <mat-radio-button [value]="true">{{'questionnaire.yes' | translate}}</mat-radio-button>
            <mat-radio-button [value]="false">{{'questionnaire.no' | translate}}</mat-radio-button>
        </mat-radio-group>

        <ng-container *ngIf="showPepName">
            <p class="mt-4">{{'customer_form.pep_name' | translate }}</p>
            <mat-form-field>
                <mat-label>{{'customer_form.first_name' | translate }}</mat-label>
                <input formControlName="firstName" matInput />
            </mat-form-field>

            <mat-form-field>
                <mat-label>{{'customer_form.last_name' | translate }}</mat-label>
                <input formControlName="lastName" matInput />
            </mat-form-field>
        </ng-container>
    </ng-container>

    <ng-container formGroupName="moneyLaundering" *ngIf="countrySettings !== 'DE' && showMoneyLaundering">

        <div class="pt-4">
            <div>
                <h3 class="text-primary">{{'customer_form.source_of_funds' | translate }}</h3>
            </div>
            <div class='grid grid-cols-1 sm:grid-cols-2 text-lg pl-6'>
                <p>
                    <mat-checkbox color='primary' formControlName='investmentIncome'>{{'customer_form.investment_income' | translate }}</mat-checkbox>
                </p>
                <p>
                    <mat-checkbox color='primary' formControlName='estateSales'>{{'customer_form.estate_sales' | translate }}</mat-checkbox>
                </p>
                <p>
                    <mat-checkbox color='primary' formControlName='endowment'>{{'customer_form.endowment' | translate }}</mat-checkbox>
                </p>
                <p>
                    <mat-checkbox color='primary' formControlName='inheritance'>{{'customer_form.inheritance' | translate }}</mat-checkbox>
                </p>
                <p>
                    <mat-checkbox color='primary' formControlName='savings'>{{'customer_form.savings' | translate }}</mat-checkbox>
                </p>
                <p>
                    <mat-checkbox color='primary' formControlName='employment'>{{'customer_form.employment' | translate }}</mat-checkbox>
                </p>
                <p>
                    <mat-checkbox color='primary' formControlName='investments'>{{'customer_form.investments' | translate }}</mat-checkbox>
                </p>
                <p>
                    <mat-checkbox color='primary' formControlName='pension'>{{'customer_form.pension' | translate }}</mat-checkbox>
                </p>
                <p>
                    <mat-checkbox color='primary' formControlName='loan'>{{'customer_form.loan' | translate }}</mat-checkbox>
                </p>
                <p>
                    <mat-checkbox color='primary' formControlName='other'>{{'customer_form.other' | translate }}</mat-checkbox>
                </p>
            </div>
            <p *ngIf="otherMoneyLaunderingValue">
                <mat-form-field class='my-4 w-full' appearance='outline'>
                    <mat-label>{{'customer_form.other' | translate }}</mat-label>
                    <textarea
                            formControlName='otherDetails'
                            matInput
                            id='otherDetails'
                            rows='3'
                    ></textarea>
                </mat-form-field>
            </p>
        </div>
        <div>
            <div>
                <h3 class="text-primary">{{'customer_form.resident_person' | translate }}</h3>
            </div>
            <div class="flex flex-col xl:flex-row justify-between font-source text-lg pb-2 pl-6">
                <mat-radio-group formControlName="residentPerson">
                    <mat-radio-button [value]="true">{{'customer_form.resident_person_local' | translate }}</mat-radio-button>
                    <mat-radio-button [value]="false" class="ml-4">{{'customer_form.resident_person_foreign' | translate }}</mat-radio-button>
                </mat-radio-group>
            </div >
        </div>
    </ng-container>


</form>